import { render, staticRenderFns } from "./observationPer1000.vue?vue&type=template&id=be300716"
import script from "./observationPer1000.vue?vue&type=script&lang=js"
export * from "./observationPer1000.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports